// Lucky Orange utility functions

/**
 * Track visitor event in Lucky Orange
 * @param {Object} userData - User data to identify visitor
 * @param {string} userData.email - User's email
 * @param {string} [userData.name] - User's name (optional)
 * @param {string} [userData.id] - User's ID (optional)
 */
export const trackVisitor = async (userData) => {
    console.log('Tracking visitor:', userData);
  if (typeof window === 'undefined' || !window.LO) return;

  try {
    // Wait for Lucky Orange to be ready
    await window.LO.$internal.ready('visitor');
    
    // Identify visitor with user data
    window.LO.visitor.identify(userData);
    
    // Track visitor event
    await window.LO.$internal.ready('events');
    window.LO.events.track('Visitor', {
      email: userData.email,
      name: userData.name,
      id: userData.id
    });
    
    console.log('Visitor tracked successfully');
  } catch (error) {
    console.error('Failed to track visitor:', error);
  }
};

/**
 * Initialize Lucky Orange tracking
 * @param {Object} userData - User data to identify visitor
 * @param {string} userData.email - User's email
 * @param {string} [userData.name] - User's name (optional)
 * @param {string} [userData.id] - User's ID (optional)
 */
export const initLuckyOrange = async (userData) => {
  if (typeof window === 'undefined' || !window.LO) return;

  try {
    // Wait for Lucky Orange to be ready
    await window.LO.$internal.ready('visitor');
    
    // Identify visitor with user data
    window.LO.visitor.identify(userData);
    
    console.log('Lucky Orange initialized successfully');
  } catch (error) {
    console.error('Failed to initialize Lucky Orange:', error);
  }
};

/**
 * Track an event in Lucky Orange
 * @param {string} eventName - Name of the event to track
 * @param {Object} [properties] - Additional properties for the event
 */
export const trackEvent = async (eventName, properties = {}) => {
  if (typeof window === 'undefined' || !window.LO) return;

  try {
    // Wait for events module to be ready
    await window.LO.$internal.ready('events');
    
    // Track the event
    window.LO.events.track(eventName, properties);
    
    console.log(`Tracked event: ${eventName}`, properties);
  } catch (error) {
    console.error('Failed to track event:', error);
  }
}; 